import { ADD_DEAL, GET_DEAL, GET_DEALS, DELETE_DEAL } from './types';
import axios from '../utils/axios';
// import { getContactById } from './contact';

export const addDeal = (formData, id, history) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const res = await axios.post(`/api/deal/contactID/${id}`, formData, config);
    dispatch({
      type: ADD_DEAL,
      payload: res.data
    });
    dispatch(getContactDeals(res.data._id));
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const editDeal = (formData, id) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.post(`/api/deal/editDeal/${id}`, formData, config);
    dispatch({
      type: ADD_DEAL,
      payload: res.data
    });
    dispatch(getContactDeals(res.data._id));
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getDealById = id => async dispatch => {
  try {
    const res = await axios.get(`/api/deal/dealID/${id}`);
    dispatch({
      type: GET_DEAL,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getContactDeals = id => async dispatch => {
  try {
    const res = await axios.get(`/api/deal/contactID/${id}`);
    dispatch({
      type: GET_DEALS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const getMyDeals = () => async dispatch => {
  try {
    const res = await axios.get('/api/deal/allMyDeals');
    dispatch({
      type: GET_DEALS,
      payload: res.data
    });
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};

export const deleteDeal = (formData, id) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    const res = await axios.post(
      `/api/deal/deleteDeal/${id}`,
      formData,
      config
    );
    dispatch({
      type: DELETE_DEAL,
      payload: res.data
    });
    dispatch(getContactDeals(res.data._id));
  } catch (err) {
    const errors = err.response.data.errors;
    if (errors) {
      errors.forEach(error => console.log(error.msg));
    }
  }
};



// WEBPACK FOOTER //
// ./src/actions/deal.js